module.exports = __webpack_public_path__ + "static/hob3-e442532ec66acff44a8fa752bab25fd2.jpg";